<nz-tabs
  class="em-tabs-vertical"
  nzTabPosition="left"
  *ngIf="partDesignStructure"
  (nzSelectedIndexChange)="revisionSelectionChange($event)"
>
  <nz-tab
    *ngFor="let revision of partDesignStructure?.revisions; trackBy: trackByRef"
    [nzTitle]="revision.revId"
  >
    <nz-descriptions nzLayout="vertical">
      <nz-descriptions-item nzTitle="Revision">
        {{ revision.revId }}
      </nz-descriptions-item>

      <nz-descriptions-item nzTitle="Release status" nzSpan="2">
        <em-display-property [value]="revision.releaseStatus"></em-display-property>
      </nz-descriptions-item>

      <nz-descriptions-item nzTitle="Change description" nzSpan="3">
        <em-display-property [value]="revision.chgNote"></em-display-property>
      </nz-descriptions-item>

      <nz-descriptions-item nzTitle="Change info nr.">
        <em-display-property [value]="revision.chgNumber"></em-display-property>
      </nz-descriptions-item>
      <nz-descriptions-item nzTitle="Change note" nzSpan="2">
        <em-display-property [value]="revision.chgShortNote"></em-display-property>
      </nz-descriptions-item>

      <nz-descriptions-item nzTitle="Datasets" nzSpan="3">
        <em-dataset-card-list [datasets]="revision.datasets"></em-dataset-card-list>
      </nz-descriptions-item>

      <ng-container *ngFor="let ref of revision.references; trackBy: trackByRef">
        <nz-descriptions-item nzTitle="CAE id">
          <em-display-property [value]="ref?.itemId ?? ''"></em-display-property>
        </nz-descriptions-item>
        <nz-descriptions-item nzTitle="CAE name" nzSpan="2">
          <em-display-property [value]="ref?.itemName ?? ''"></em-display-property>
        </nz-descriptions-item>

        <nz-descriptions-item nzTitle="Datasets" nzSpan="3">
          <em-dataset-card-list
            [datasets]="ref?.revisions?.[0]?.datasets ?? []"
          ></em-dataset-card-list>
        </nz-descriptions-item>
      </ng-container>

      <nz-descriptions-item nzTitle="Weight" nzSpan="3">
        <em-display-property [value]="revision.weight ?? ''"></em-display-property>
      </nz-descriptions-item>

      <nz-descriptions-item nzTitle="Project IDs" nzSpan="3">
        <em-display-property [value]="revision.projects | joinDeep: 'id'"></em-display-property>
      </nz-descriptions-item>

      <nz-descriptions-item nzTitle="Project Objects" nzSpan="3">
        <em-display-property [value]="revision.projects | joinDeep: 'name'"></em-display-property>
      </nz-descriptions-item>

      <nz-descriptions-item nzTitle="2D M-Codes" nzSpan="3">
        <nz-alert
          *ngIf="mCodesError$ | async as errorMessage; else loadingOrResult"
          nzType="error"
          [nzMessage]="errorMessage"
          nzShowIcon
        ></nz-alert>

        <ng-template #loadingOrResult>
          <div *ngIf="isMCodesLoading$ | async; else result" class="spinner-container">
            <nz-spin nzSimple nzSize="large"></nz-spin>
          </div>
        </ng-template>

        <ng-template #result>
          <ng-container *ngIf="mCodes$ | async as mCodes; else noMCodeData">
            <ng-container *ngIf="mCodes.length; else noMCodes">
              <nz-tag class="tag" *ngFor="let mCode of mCodes; trackBy: trackByRef">
                {{ mCode }}
              </nz-tag>
            </ng-container>
          </ng-container>

          <ng-template #noMCodes>
            <em-display-property
              [value]="''"
              emptyText="No M-codes on this revision"
            ></em-display-property>
          </ng-template>

          <ng-template #noMCodeData>
            <em-display-property [value]="''" emptyText="Not loaded"></em-display-property>
          </ng-template>
        </ng-template>
      </nz-descriptions-item>
    </nz-descriptions>
  </nz-tab>
</nz-tabs>
